<template>
  <v-dialog persistent v-model="dialogDetails.popup"
    :content-class="dialogDetails.dialogType === 'filter' ? dialogDetails.type === 'Pending Disposition' ? 'filter-brandCallLog pending_disposition_filter' :
      'filter-brandCallLog' : dialogDetails.active_tab === 'Pending Decision' ? 'update-brandCallLog' : 'update-brandCallLog'"
    :max-width="dialogDetails.width || '750px'">
    <v-card class="v-card-100 mt-0">
      <v-card class="v-card-100 m-0"
        v-if="['update', 'details', 'successAndError'].includes(dialogDetails.dialogType,)">
        <v-card-title class="d-flex align-center">
          <span>{{ dialogDetails.title || "" }}</span>
          <v-spacer></v-spacer>
          <v-btn icon variant="solo" @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </v-card>

      <v-form @submit.prevent="handleSubmit"
        v-if="['update', 'filter', 'successAndError'].includes(dialogDetails.dialogType)">
        <v-card-text>
          <v-container fluid>
            <template
              v-if="(dialogDetails.dialogType === 'update') && dialogDetails.active_tab === 'Pending Information'">
              <v-row v-for="(row, index) in rows" :key="index">
                <v-col cols="12" sm="5" md="6">
                  <template v-if="row.element === 'select'">
                    <v-autocomplete v-model="row.seletedValue" variant="outlined" :items="row.options"  hide-details
                      @update:modelValue="(e) => handleChange(e, row)" item-title="label" item-value="field"  :class="index == rows.length-1 ? 'mb-2' : ''"
                      label="Select data field" color="primary" style="max-width: 300px;">
                      <template v-slot:item="{ props, item }">
                        <v-list-item v-bind="props" title="">
                          {{ item.raw.label }}
                          <span :class="{ 'text-red-500': item.raw.is_mandatory }">
                            {{ item.raw.is_mandatory ? " *" : "" }}
                          </span>
                        </v-list-item>
                      </template>
                    </v-autocomplete>
                  </template>
                  <v-span style="text-decoration: underline;color:red;cursor: pointer;font-size: 16px;" v-if="rows.length > 1 && index == rows.length-1" @click="deleteLastRow">Delete</v-span>
                </v-col>
                <v-col cols="12" sm="5" md="6">
                  <template v-if="row.inputType === 'file'">
                    <v-file-input v-model="row.file" variant="underlined" color="primary" :disabled="!row.seletedValue || row.original_data != ''"
                      :accept="row.accept" clear-icon="mdi-close" :label="row.inputLabel">
                    </v-file-input>
                  </template>
                  <template v-else-if="row.inputType === 'date'">
                    <!-- <v-text-field variant="outlined" color="primary" type="date" :disabled="!row.seletedValue || row.original_data != ''" :rules="[validateDate]" @input="dateChanged(row)"
                      v-model="row.value"  :max="today" :label="row.inputLabel">
                    </v-text-field> -->
                    <v-menu v-model="row.menu_14" :close-on-content-click="false" :return-value.sync="row.value" transition="scale-transition" offset-y min-width="320px">
                      <template v-slot:activator="{ props }">
                        <v-text-field variant="outlined" hide-details
                          v-model="row.formatted_date"
                          :label="row.inputLabel"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="props"
                        ></v-text-field>
                      </template>
                      <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                        <v-date-picker :max="new Date().toISOString().substr(0, 10)"  v-model="isDatePickerClaimTicketDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                        </v-date-picker>
                        <v-card-action class="d-flex justify-end pb-3">
                          <v-spacer></v-spacer>
                          <v-btn variant="text" class=" text-none" color="primary" @click="row.menu_14= false">Cancel</v-btn>
                          <v-btn variant="text" class=" text-none" color="primary" @click="handleSaveDateByRow(row, 'isDatePickerClaimTicketDate')">Ok</v-btn>
                        </v-card-action>
                      </v-card>
                    </v-menu>
                  </template>
                  <template v-else>
                    <v-text-field v-model="row.value" :disabled="!row.seletedValue || row.original_data != ''"
                      :label="row.inputLabel" color="primary" variant="outlined"></v-text-field>
                  </template>
                </v-col>
              </v-row>
            </template>
            <v-row class="d-flex gap-2 flex-wrap"
              v-if="(dialogDetails.dialogType === 'update') && dialogDetails.active_tab === 'Pending Decision'">
              <!-- <v-row class="d-flex gap-2 flex-wrap" v-if="$isRelianceClient()" style="width: 100%;"> -->
                <v-col cols="12"
                  :sm="dialogDetails.fieldData.brand_decision_value === 'Reject' && $isRelianceClient() ? '6' : '6'"
                  :md="dialogDetails.fieldData.brand_decision_value === 'Reject' && $isRelianceClient() ? '6' : '6'">
                  <v-autocomplete variant="outlined" :items="dialogDetails.fieldData.brand_decision_options"
                    v-model="dialogDetails.fieldData.brand_decision_value" item-title="id" item-value="code"
                    label="Brand Decision *" @update:modelValue="getValue(dialogDetails.fieldData.brand_decision_value)"
                    :disabled="dialogDetails.brandDecisionDis">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12"
                  :sm="dialogDetails.fieldData.brand_decision_value === 'Reject' && $isRelianceClient() ? '6' : '6'"
                  :md="dialogDetails.fieldData.brand_decision_value === 'Reject' && $isRelianceClient() ? '6' : '6'"
                  v-if="$isRelianceClient() && dialogDetails.active_tab === 'Pending Decision' && dialogDetails.fieldData.brand_decision_value === 'Reject'">
                  <v-autocomplete variant="outlined" color="primary"
                    :items="dialogDetails.fieldData.reject_reason_options"
                    v-model="dialogDetails.fieldData.reject_reason"
                    label="Reject Reason *" @update:modelValue="getValue(dialogDetails.fieldData.reject_reason)"
                    :disabled="dialogDetails.brandDecisionDis">
                  </v-autocomplete>
                </v-col>
              <!-- </v-row> -->
              <v-col cols="12" :sm="dialogDetails.fieldData.brand_decision_value === 'Reject' ? '12' : '6'"
                :md="dialogDetails.fieldData.brand_decision_value === 'Reject' ? '12' : '6'"
                v-if="!$isRelianceClient()">
                <v-autocomplete variant="outlined" color="primary"
                  :items="dialogDetails.fieldData.brand_decision_options"
                  v-model="dialogDetails.fieldData.brand_decision_value" item-title="id" item-value="code"
                  label="Brand Decision" @update:modelValue="getValue(dialogDetails.fieldData.brand_decision_value)"
                  :disabled="dialogDetails.brandDecisionDis">
                </v-autocomplete>
              </v-col>
              <template v-if="dialogDetails.fieldData.brand_decision_value !== 'Reject'">
                <v-col cols="12" sm="5" md="6">
                  <v-text-field variant="outlined" :rules="alphanumericRule" color="primary"
                    label="Brand Approval Reference number *"
                    v-model="dialogDetails.fieldData.brand_approval_number_value"
                    :disabled="dialogDetails.referenceNumberDis"></v-text-field>
                </v-col>

                <template v-if="dialogDetails.fieldData.brand_decision_value === 'Discount'">
                  <v-col cols="12" sm="12" md="12" class="pb-0">
                    <v-sheet>Enter discount percentage/value below.</v-sheet>
                  </v-col>
                  <v-col cols="12" sm="5" md="6">
                    <v-text-field variant="outlined" color="primary" label="Discount Percentage *"
                      @focus="handleDiscount('Discount Percentage')" :rules="[...numberRule]"
                      @update:modelValue="(e) => handleChangeDiscount(e, 'Discount Percentage')"
                      :disabled="dialogDetails.discountPercentageDis || dialogDetails.discountValueDis"
                      v-model.number="dialogDetails.fieldData.discount_percentage"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="5" md="6">
                    <v-text-field :disabled="dialogDetails.discountValueDis || dialogDetails.discountPercentageDis"
                      :rules="numberRule" v-model.number="dialogDetails.fieldData.discount_value" variant="outlined"
                      color="primary" @focus="handleDiscount('Discount value')"
                      @update:modelValue="(e) => handleChangeDiscount(e, 'Discount value')"
                      label="Discount Value (₹) *"></v-text-field>
                  </v-col>
                </template>
                <v-col cols="12" sm="5" md="6" v-if="dialogDetails.fieldData.brand_decision_value === 'RTV'">
                  <v-text-field :rules="alphanumericRule" variant="outlined" color="primary"
                    label="Credit Note Number (Optional)" v-model="dialogDetails.fieldData.credit_note_number"
                    :disabled="dialogDetails.creditNoteDis"></v-text-field>
                </v-col>
                <template v-if="['RTV', 'Discount'].includes(dialogDetails.fieldData.brand_decision_value) && !(dialogDetails.fieldData.brand_decision_value === 'Discount' && dialogDetails.fieldData.show_discount_in_vendor_amount)">
                  <v-col cols="12" sm="5" md="6">
                    <v-text-field variant="outlined" color="primary" :rules="numbercheck" :patern="[/^[0-9]*$/]"
                      :label="`Credit Note Amount (₹) ${dialogDetails.fieldData.brand_decision_value === 'Discount' ? '(Optional)' : ''} *`"
                      v-model="dialogDetails.fieldData.credit_note_amount"
                      @update:modelValue="(value) => handleChangeNumberValue(value)"
                      :disabled="dialogDetails.creditNoteAmountDsi"></v-text-field>
                    <!-- v-model="dialogDetails.fieldData.credit_note_amount" -->
                  </v-col>
                </template>
                <template v-if="['Repair'].includes(dialogDetails.fieldData.brand_decision_value)">
                  <v-col cols="12" sm="5" md="6">
                    <v-combobox :items="dialogDetails.fieldData.repair_type_location_options" item-title="name"
                      item-value="name" label="Select Location"
                      v-model="dialogDetails.fieldData.repair_type_location_value"
                      :disabled="dialogDetails.repairTypeDis" variant="outlined"></v-combobox>
                  </v-col>
                </template>
              </template>
              <template v-if="true">
                <v-col cols="12" sm="5" md="6">
                  <v-file-input v-model="dialogDetails.fieldData.brand_approval_attachment" accept=".pdf, .jpg, .jpeg, .png"  variant="outlined"
                    label="Brand Approval Attachment" prepend-icon="" prepend-inner-icon="mdi-paperclip">
                  </v-file-input>
                </v-col>
              </template>
              <template v-if="true">
                <v-col cols="12" sm="5" md="6">
                  <v-text-field variant="outlined" :rules="alphanumericRule" label="Approval Reference Text" v-model="dialogDetails.fieldData.approval_reference_text" :disabled="dialogDetails.app_ref_text_dis"></v-text-field>
                </v-col>
              </template>
            </v-row>
            <v-row
              v-if="dialogDetails.dialogType === 'update' && dialogDetails.active_tab !== 'Pending Information' && dialogDetails.active_tab !== 'Pending Decision'">
              <v-col cols="12" :sm="row.col || '5'" :md="row.col || '6'" v-for="(row, index) in rows" :key="index">
                <template v-if="row.element === 'select'">
                  <v-autocomplete variant="outlined" :label="row.label" :items="row.options" v-model="row.value"
                    :disabled="row.disablity || false" :item-title="row.itemText"
                    :item-value="row.itemValue"></v-autocomplete>
                </template>
                <template v-else-if="row.element === 'file'">
                  <v-file-input :multiple="row.multiple || false" :accept="row.accept" v-model="row.file"
                    :disabled="row.disablity || false" :label="row.label">
                  </v-file-input>
                </template>
                <template v-else-if="row.element === 'date'">
                  <!-- <v-text-field variant="outlined" type="date" v-model="row.value" :label="row.label" :rules="[validateDate]" :max="today" @input="dateChanged(row)">
                                    </v-text-field> -->
                  <v-menu v-model="row.menu_14" :close-on-content-click="false" :return-value.sync="row.value" transition="scale-transition" offset-y min-width="320px">
                    <template v-slot:activator="{ props }">
                      <v-text-field variant="outlined" hide-details
                        v-model="row.formatted_date"
                        :label="row.label"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="props"
                      ></v-text-field>
                    </template>
                    <v-card class="m-0 overflow-hidden calendar-layout" width="300">
                      <v-date-picker :max="new Date().toISOString().substr(0, 10)"  v-model="row.isDatePickerClaimTicketDate" hide-header color="primary" min-width="200" max-width="300" scrollable>
                      </v-date-picker>
                      <v-card-action class="d-flex justify-end pb-3">
                        <v-spacer></v-spacer>
                        <v-btn variant="text" class=" text-none" color="primary" @click="row.menu_14= false">Cancel</v-btn>
                        <v-btn variant="text" class=" text-none" color="primary" @click="handleSaveDateByRowElement(row, 'isDatePickerClaimTicketDate')">Ok</v-btn>
                      </v-card-action>
                    </v-card>
                  </v-menu>
                </template>
                <template v-else-if="row.element === 'alphanumeric'">
                  <v-text-field v-model="row.value" :rules="alphanumericRule" :label="row.label" variant="outlined"
                    :readonly="row.readonly || false" :disabled="row.disablity || false"></v-text-field>
                </template>
                <template v-else>
                  <v-text-field v-model="row.value" :label="row.label" color="primary" variant="outlined"
                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9]/g, '');" :readonly="row.readonly || false"
                    :disabled="row.disablity || false"></v-text-field>
                </template>
                <!-- {{ renderHtmlTag(row) }} -->
              </v-col>
            </v-row>
            <v-row v-if="dialogDetails.dialogType === 'filter'" :style="{width: dialogDetails.width}" class="pr-8">
              <v-col sm="6" md="6" xs="9" cols="12" lg="" v-for="(row, index) in rows" :key="index">
                <template v-if="row.element === 'select'">
                  <v-select variant="outlined" color="primary" :label="row.label" :items="row.options"
                    v-model="row.value" :item-title="row.itemText || 'id'"
                    :item-value="row.itemValue || 'value'"></v-select>
                </template>
                <template v-if="row.element === 'search'">
                  <v-text-field variant="outlined" color="primary" :label="row.label" v-model="row.value"
                    prepend-inner-icon="mdi-magnify"></v-text-field>
                </template>
                <template v-if="row.element === 'select&search'">
                  <v-autocomplete prepend-inner-icon="mdi-magnify" variant="outlined" color="primary" :label="row.label"
                    :items="row.options" v-model="row.value" :item-title="row.itemText || 'id'"
                    :item-value="row.itemValue || 'value'" class="v_autocomplete" :multiple="row.multiple || false">
                  </v-autocomplete>
                </template>
                <template v-if="row.element === 'dropdownwithaction'">
                  <div>
                    <v-menu v-model="row.nestedDialog" :close-on-content-click="false" transition="scale-transition"
                      offset-y class="filter_disposition_dailog">
                      <template v-slot:activator="{ props }">
                        <v-select variant='outlined' v-model="row.value" :label="row.label" readonly hide-details
                          tag="button" color="primary" v-bind="props" style="height: 56px !important;font-size: 16px; font-weight: 400;"></v-select>
                      </template>
                      <v-list>
                        <v-sheet>
                          <v-card-title v-if="row.title">
                            <span>{{ row.title }}</span>
                          </v-card-title>
                          <template v-for="(menuItem, index) in row.menuItems">
                            <v-card-text v-if="menuItem.inputTag === 'checkBox'" :key="index" class="py-0">
                              <v-row>
                                <v-col cols="10">{{ menuItem.label }}</v-col>
                                <v-col cols="2" class="text-right pa-0">
                                  <v-checkbox hide-details class="ma-0" :item-value="menuItem.key" :value="menuItem.key"
                                    v-model="menuItem.value"></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <div v-else-if="menuItem.inputTag === 'number'" class="d-flex mb-2">
                              <div class="w-25">
                                <div class="d-flex align-items-center h-100 justify-center">
                                  {{
                                    menuItem.label }}</div>
                              </div>
                              <div class="w-75 px-2">
                                <v-text-field variant="outlined" color="primary" hide-details type="number"
                                  :label="menuItem.inputLabel" :rules="numberRule" v-model.number="menuItem.value"
                                  class="ma-0"></v-text-field>
                              </div>
                            </div>
                            <v-card-text v-else>
                              <v-col cols="4">{{ menuItem.label }}</v-col>
                              <v-col cols="8">
                                <v-text-field variant="outlined" color="primary" hide-details
                                  :label="menuItem.inputLabel" v-model="menuItem.value" class="ma-0"></v-text-field>
                              </v-col>
                            </v-card-text>
                          </template>
                          <v-divider thickness="2"></v-divider>
                          <v-card-actions class="text-center">
                            <v-spacer></v-spacer>
                            <v-btn size="small" variant="outlined" class="text-none" color="primary"
                              @click="handleNextDialogCancel(row)">Cancel</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn size="small" variant="flat" class="text-none" color="primary"
                              @click="row.nestedDialog = false">Submit</v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-sheet>
                      </v-list>

                    </v-menu>
                  </div>
                  <v-chip class="filterchip text-wrap my-1"
                    v-for="menuItem in row.menuItems.filter(item => ![undefined, '', false].includes(item.value))"
                    :key="menuItem.label" color="#fffff" variant="outlined">
                    <span>{{ menuItem.value }}</span>&nbsp;&nbsp;
                    <v-icon size="small" @click="handlemenuItemClose(menuItem)"
                      class="menuItemCloseIcon">mdi-close</v-icon>
                  </v-chip>&nbsp;
                </template>
                <template v-if="row.element === 'selectwithaction'">
                  <v-select variant="outlined" v-model="row.value" :label="row.label"></v-select>
                </template>

              </v-col>
            </v-row>
            <v-row v-if="dialogDetails.dialogType === 'successAndError'">
              <v-col>
                <v-card-text class="text-center">
                  <span> {{ dialogDetails.message }}</span>
                </v-card-text>
              </v-col>
            </v-row>

            <v-row v-if="addColoumns.show">
              <v-col cols="12">
                <v-btn variant="outlined" color="primary" class="mb-3" @click="addMoreRows">
                  <v-icon>mdi-plus</v-icon>
                  {{ addColoumns.addText }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions center>
          <v-spacer></v-spacer>
          <v-btn small text color="primary" variant="outlined" class="btn-cancel mr-2 mb-3 text-none" v-if="dialogDetails.closeBtn" @click="handleClosePopup">{{ dialogDetails.closeText }}</v-btn>
          <v-btn small color="primary" :disabled="disabledSubmitbtn || checkNumber" variant="flat" type="submit" class="mb-3 text-none" v-if="dialogDetails.submitBtn">{{dialogDetails.submitText}}</v-btn>
          <v-spacer v-if="dialogDetails.dialogType !== 'filter'"></v-spacer>

        </v-card-actions>
      </v-form>
      <v-container v-if="['details'].includes(dialogDetails.dialogType)">
        <v-row v-for="(row, index) in rows" :key="index" class="px-2">
          <template v-if="row.link">
            <v-col cols="12" sm="5" md="6">
              {{ row.key }}
              <template v-if="row.is_mandatory">*</template>
            </v-col>
            <v-col cols="12" sm="5" md="6">
              <template v-if="row.value">
                <a v-if="row.data_type === 'doc' || row.data_type === 'image' || row.data_type === 'video'"
                  @click="handleLinkRedirect(row, row.value)" style="color: #1976d2;">
                  <u class="cursor-pointer">{{ row.value && row.value.name || "N/A" }}</u>
                </a>
                <p v-if="row.data_type === 'info'">
                  {{ row.value }}
                </p>
                <p v-if="row.data_type === 'date'">
                 {{ row.value ? row.value.split('-').reverse().join('/') : '-' }}
                </p>
              </template>
              <template v-else>
                <a v-if="dialogDetails.active_tab === 'Pending Information'"
                  @click="handlePopupLinkClick(dialogDetails.data, row)" style="color: #1976d2;" class="cursor-pointer">
                  <u>Update</u>
                </a>
                <span v-else>N/A</span>
              </template>
            </v-col>
          </template>
          <template v-else>
            <v-col cols="12" sm="5" md="6">
              {{ row.key }}
            </v-col>
            <v-col cols="12" sm="5" md="6">
              {{ row.value }}
            </v-col>
          </template>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { mixinHelper } from "@//mixins/mixin-helper.js";

export default {
  mixins: [mixinHelper],
  props: {
    dialogDetails: Object,
    rows: Array,
    addMoreRows: Function,
    addColoumns: Object,
    handleClosePopup: Function,
    handleSubmit: Function,
    handlePopupLinkClick: Function,
    disabledSubmitButton: Boolean
  },
  data() {
    return {
          overlay: false,
          organization_name: '',
          isDatePickerClaimTicketDate: new Date(),
          credit_note_amount_for_auto_population: '',
          
          // Validation Rules
          numberRule: [
            v => /^[0-9]*$/.test(v) || 'Only numbers allowed'
          ],
          maxPercentageRule: v => (v <= 100) || "Percentage cannot exceed 100",
          alphanumericRule: [
            v => /^[a-zA-Z0-9]*$/.test(v) || 'Only alphanumeric characters are allowed',          ],
          
          checkNumber: false,
          isDatePickerDate: new Date()
      };
    },
  watch: {
    'dialogDetails.fieldData.credit_note_amount': function (newVal, oldVal) {
      if (newVal !== "") {
        this.credit_note_amount_for_auto_population = ''; // Clear stored value
      }
    }
  },
  computed: {
    today() {
            const date = new Date();
            return date.toISOString().split('T')[0];
    },
    disabledSubmitbtn: function () {
      let unfillField = false
      if ((this.dialogDetails.active_tab === 'Pending Decision') && (this.dialogDetails.dialogType === 'update')) {
        let credit_note_number = this.dialogDetails.fieldData.credit_note_number
        let brand_approval_value = this.dialogDetails.fieldData.brand_approval_number_value
        let brand_approval_field = brand_approval_value ? !/^[a-zA-Z0-9]*$/.test(brand_approval_value) : true

        let brand_decision_field = this.dialogDetails.fieldData.brand_decision_value
        let discount_percentage = this.dialogDetails.fieldData.discount_percentage
        let discount_value = this.dialogDetails.fieldData.discount_value
        let credit_note_amount = this.dialogDetails.fieldData.credit_note_amount || ""
        let valid_credit_amount = ["RTV"].includes(brand_decision_field) ? credit_note_amount === "" && !this.dialogDetails.creditNoteAmountDsi : false
        let location = this.dialogDetails.fieldData.repair_type_location_value || null
        let repair_type = ["Repair"].includes(brand_decision_field) ? location === "" && !this.dialogDetails.repairTypeDis : false
        let discount_field = ["Discount"].includes(brand_decision_field) ? (discount_percentage === "") && (discount_value === "") && !this.dialogDetails.discountPercentageDis && !this.dialogDetails.discountValueDis : false
        let reject_field = brand_decision_field === "Reject"
        let credit_note_number_field = false
        if (credit_note_number) {
          if (/^[a-zA-Z0-9]*$/.test(credit_note_number)) {
            credit_note_number_field = false
          } else {
            credit_note_number_field = this.dialogDetails.creditNoteAmountDsi
          }
        }
        var all_disabled = ["RTV"].includes(brand_decision_field) ? this.dialogDetails.creditNoteAmountDsi && this.dialogDetails.creditNoteDis :
          ["Replacement"].includes(brand_decision_field) ? this.dialogDetails.creditNoteDis :
            ["Discount"].includes(brand_decision_field) ? this.dialogDetails.discountPercentageDis && this.dialogDetails.discountValueDis && this.dialogDetails.creditNoteAmountDsi :
              ["Repair"].includes(brand_decision_field) ? this.dialogDetails.repairTypeDis : false
        all_disabled = all_disabled && this.dialogDetails.referenceNumberDis && this.dialogDetails.brandDecisionDis
        if (reject_field) {
          unfillField = !this.dialogDetails.fieldData.reject_reason
        } else {
          unfillField = (brand_approval_field && !this.dialogDetails.referenceNumberDis) || (!brand_decision_field && !this.dialogDetails.brandDecisionDis)
            || all_disabled || discount_field || valid_credit_amount || repair_type || credit_note_number_field
          // unfillField = brand_approval_field || brand_decision_field === "" || discount_field || valid_credit_amount || repair_type || credit_note_number_field
        }
      } else if (this.dialogDetails.dialogType === 'filter') {
        unfillField = false
      } else if (this.dialogDetails.dialogType === 'update') {
        // let unfillValue = false
        if (this.dialogDetails.active_tab === 'Pending BCL Tickets') {
          if ((!this.rows[0].value && !this.rows[0].disablity) || (this.rows[1].disablity && this.rows[0].disablity))
            unfillField = true;
          if (!this.rows[1].value && !this.rows[1].disablity)
            unfillField = true;
        } else if (this.dialogDetails.active_tab === 'Pending Inspection') {
          if ((!this.rows[0].value && !this.rows[0].disablity) || (this.rows[1].disablity && this.rows[0].disablity))
            unfillField = true;
          if (!this.rows[1].file && !this.rows[1].file.name && !this.rows[1].disablity)
            unfillField = true;
        }

      } else {
        let unfillValue = this.rows.map(row => row.value || row.file)
        unfillField = unfillValue.includes(undefined)
      }
      return unfillField || this.disabledSubmitButton
    },
    formatDateValue() {
      let dateRow = this.rows.find(item => item.element === 'date')
      if (!dateRow.value) return null

      const [year, month, day] = dateRow.value.split('-')
      return `${day}/${month}/${year}`
    }
  },
  async created() {
    this.organization_name = this.$store.state.organization_name;
  },
  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    handleSaveDate(dateObject) {
      // this.menu_16 =  false
      dateObject.datePopup = false
      dateObject.value = this.formatted_filter_date(this.isDatePickerDate)
    },
    handleChangeNumberValue(value, fieldData) {
      const number = Number(value)
      if (!isNaN(number) && number >= 0) {
        this.numbercheck = [true]
        this.checkNumber = false
      } else {
        this.numbercheck = ['Only numbers allowed']
        this.checkNumber = true
      }
    },
    handleNextDialogCancel(row) {
      row.menuItems = row.menuItems.map(item => ({ ...item, value: "" }))
      row.nestedDialog = false
    },
    handlemenuItemClose(menuItem) {
      menuItem.value = false
    },
    handleChange(value, rowData) {

      if (value && rowData.options) {
        let findOption = rowData.options.find(option => option.field === value)
        rowData.optionData = findOption
        rowData.value = ''
        rowData.original_data = findOption.original_data
                if(rowData.original_data)
                    rowData.value = findOption.original_data
        rowData.inputType = findOption && findOption.data_type === "doc" || findOption.data_type === "image" || findOption.data_type === "video" ? "file" : findOption.data_type === "date" ? 'date' : "text"
        if(rowData.inputType == 'date')
          this.isDatePickerClaimTicketDate= new Date()
        // rowData.accept = findOption && findOption.data_type === "doc" || findOption.data_type === "image" || findOption.data_type === "video" ? 'application' : ""
        rowData.accept = !findOption ? '' : findOption.data_type === "doc" ? '.pdf' : findOption.data_type === "image" ? "image/png, image/jpeg" : findOption.data_type === "video" ? "video/mp4, video/x-m4v" : ""
      }
    },
    handleLinkRedirect(data, doc) {
      window.open(doc.url, '_blank');
    },
    handleDiscount(type) {
      if (type === "Discount Percentage") {
        this.dialogDetails.fieldData.discount_value_disabled = true
        this.dialogDetails.fieldData.discount_percentage_disabled = false
      } else {
        this.dialogDetails.fieldData.discount_value_disabled = false
        this.dialogDetails.fieldData.discount_percentage_disabled = true
      }
    },
    handleChangeDiscount(value, type) {
      let purchasePrice = this.dialogDetails.fieldData.benchmark_price
      if (type === "Discount Percentage") {
        let discount_value = Math.round((purchasePrice * value) / 100)
        this.dialogDetails.fieldData.discount_value = discount_value || ""
        this.dialogDetails.fieldData.discount_value_disabled = true
      } else {
        this.dialogDetails.fieldData.discount_percentage_disabled = true
        this.dialogDetails.fieldData.discount_percentage = Math.round((value / purchasePrice) * 100)
      }
      if (value.length === 0) {
        this.dialogDetails.fieldData.discount_value_disabled = false
        this.dialogDetails.fieldData.discount_percentage_disabled = false
        this.dialogDetails.fieldData.discount_percentage = ""
        this.dialogDetails.fieldData.discount_value = ""
      }
    },
    validateDate(value) {
        const date1 = new Date(value)
        const date2 = new Date(this.today)
        date1.setHours(0,0,0,0)
        date2.setHours(0,0,0,0)
        if (date1 > date2) {
          return 'Date cannot be in the future';
        }
        return true;
      },
      dateChanged(row){
        if(this.validateDate(row.value) == 'Date cannot be in the future'){
          this.$toast.error("Please select past date only!")
          row.value = ''
        }
      },
      handleSaveDateByRow(dateState, selectDateState){
        dateState['value'] = this.formatted_filter_date(this[selectDateState])
        dateState['formatted_date'] = dateState['value'].split('-').reverse().join('/')
        dateState['menu_14'] = false
      },
      handleSaveDateByRowElement(dateState, selectDateState){
        dateState['value'] = this.formatted_filter_date(dateState[selectDateState])
        dateState['formatted_date'] = dateState['value'].split('-').reverse().join('/')
        dateState['menu_14'] = false
      },
    deleteLastRow(){
        const index = this.rows.length- 1
        this.rows.splice(index,1)
    },
    getValue(value) {
      if (!this.credit_note_amount_for_auto_population) {
        this.credit_note_amount_for_auto_population = this.dialogDetails.fieldData.credit_note_amount
      }
      if (value === 'Discount') {
        this.dialogDetails.creditNoteDis = true 
        this.dialogDetails.fieldData.credit_note_amount = ""
      } else {
        this.dialogDetails.fieldData.credit_note_amount = this.credit_note_amount_for_auto_population
        this.dialogDetails.creditNoteDis = false
      }

    }
    },
  }

</script>
<style>
  .v-dialog:has(.filter-brandCallLog){
    justify-content: right!important;
    align-items: baseline;
    top: 15rem;
  }
  /* .v-dialog>.v-overlay__content, .v-dialog>.v-overlay__content>form {
    display: block !important;
    min-height: 0;
    overflow: auto !important;
} */
.v-dialog > .v-overlay__content > .v-card{
  display: block !important;
}

.btn-text {
  text-transform: capitalize !important;
}

.btn-text>.v-btn__content {
  color: rgba(53, 46, 46, 0.6) !important;
}
.v-menu__content--fixed{
   max-width: min-content !important;
}
  .v_autocomplete{
      max-width: 300px;
  }
  @media (max-width: 1400px) {
  .v_autocomplete{
      max-width: 100% !important;
  }
}
.v-field__input{
  display: block !important;
}
</style>
